import React from "react";
import Dropzone from "dropzone";
import Cx from "classnames";
import FileLabelEditor from "../FileLabelEditor";

import { instantSave } from "../../helpers.js";
import styles from "./styles.scss";
import DocActions from "./DocActions";
import ArchivedDocActions from "./DocActions/archivedDocActions";
import { PlusIcon } from "./PlusIcon/index.jsx";

Dropzone.autoDiscover = false;

// TODO -- move to shared helpers.js with image uploader
const humanFileSize = (bytes, si = true, dp = 1) => {
  const thresh = 1000;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
};

export default class DocUploader extends React.Component {
  state = {
    items: [],
    itemsUndo: [],
    archivedItems: [],
  };

  handleDrop = (acceptedFiles) => {
    console.log(acceptedFiles);
  };

  undo = () => {
    const { itemsUndo, archivedItemsUndo } = this.state;
    this.setState({
      items: itemsUndo,
      archivedItems: archivedItemsUndo,
    });
  };

  updateArchivedFilesVal = () => {
    const { archivedItems } = this.state;
    const archivedField = $(".files_archived").val();
    let archivedFiles = archivedField.length
      ? JSON.parse(archivedField)
      : { doc: [] };
    archivedFiles["doc"] = archivedFiles["doc"] || [];
    archivedFiles["doc"] = archivedItems.map((i) => i.id);

    $(".files_archived").val(JSON.stringify(archivedFiles));
  };

  handleAddedFile = (file) => {
    if (this.props.maxFiles && this.state.items.length >= this.props.maxFiles) {
      alert(`You can upload a maximum of ${this.props.maxFiles} files here.`);
    } else {
      let dz = this._dz;
      console.log("added");
      console.log(file);

      const newItem = {
        status: "added",
        filename: file.name,
        size: file.size,
        uuid: file.upload.uuid,
      };

      this.setState({
        items: this.state.items.concat(newItem),
      });

      const options = {
        filename: file.name,
        type: file.type,
        _: Date.now(),
      };

      $.ajax({
        url: "/presign_b2",
        data: options,
        type: "GET",
        // async: false,
        success: (response) => {
          console.log("response test", response);

          file.dynamicUrl = response["url"];
          // dz.options.url = response['url'];
          dz.enqueueFile(file);
        },
      });
    }
  };

  handleSending = (file, xhr) => {
    console.log("file sending", file);
    const { name, dynamicUrl } = file;
    // non-ASCII characters in filename must be encoded
    // https://stackoverflow.com/a/64317676/8749164
    const filename = encodeURIComponent(name.replace("'", "`")).replace(
      /[!'()*]/g,
      (c) => {
        return "%" + c.charCodeAt(0).toString(16);
      }
    );

    xhr.open("PUT", dynamicUrl);
    // xhr.setRequestHeader(
    //   "Content-Disposition",
    //   `inline; filename="${filename}"`
    // );
    let _send = xhr.send;
    xhr.send = function () {
      _send.call(xhr, file);
    };

    const items = this.state.items.map((item) => {
      if (item.uuid === file.upload.uuid)
        return {
          ...item,
          status: "uploading",
        };
      return item;
    });

    this.setState({ items });
  };

  handleUploadprogress = (data) => {
    const items = this.state.items.map((item) => {
      if (item.uuid === data.upload.uuid)
        return {
          ...item,
          progress: data.upload.progress,
        };
      return item;
    });

    this.setState({ items });
  };

  handleError = (data, response) => {
    console.log("data error", data);
    console.log("response error", response);

    const status_code =
      typeof response.status !== "undefined" ? response.status : "";

    console.log("status_code", status_code);

    this._dz.processQueue();

    window.unsavedChanges(false);

    const items = this.state.items.map((item) => {
      if (item.uuid === data.upload.uuid)
        return {
          ...item,
          status: "error",
          filename: response,
          progress: null,
        };
      return item;
    });

    this.setState({ items });
  };

  handleSuccess = (data) => {
    console.log("data", data);
    let dz = this._dz;
    const doc = {
      id: data.upload.filename,
      storage: "cache",
      metadata: {
        size: data.size,
        filename: data.name,
        mime_type: data.type,
      },
    };
    console.log(doc);
    console.log(data.previewElement);
    console.log("success data", data);

    let that = this;
    // After a file is successfully uploaded, we need to send it back
    // to Rails so that it can be attached to the Doc model
    $.ajax("/docs", {
      method: "POST",
      data: { doc: { docfile: JSON.stringify(doc) } },
    }).done((response) => {
      console.log("response docs POST", response);

      dz.processQueue();

      const items = that.state.items.map((item) => {
        if (item.uuid === data.upload.uuid)
          return {
            ...response,
            status: "processed",
            progress: 0,
          };
        return item;
      });

      console.log("items success", items);

      that.setState({ items });
    });
  };

  handleDocAction = (items, archivedItems) => {
    // pass state up from DocAction component to DocUploader
    this.setState({ items, archivedItems });
  };

  handleClickItem = (e, itemId) => {
    const items = this.state.items.map((i) => {
      let item = i;
      if (item.id === itemId) item.selected = !item.selected;

      return item;
    });

    this.setState({ items });
  };

  handleClickArchivedItem = (e, itemId) => {
    const archivedItems = this.state.archivedItems.map((i) => {
      let item = i;
      if (item.id === itemId) item.selected = !item.selected;

      return item;
    });

    this.setState({ archivedItems });
  };

  componentDidUpdate(prevProps, prevState) {
    // if the doc IDs have changed then save
    if (
      prevState.items.map((i) => i.id).toString() !==
      this.state.items.map((i) => i.id).toString()
    ) {
      // prevent scenario where undo button deletes all the docs right after component mounts
      const itemsUndo = prevState.items.length
        ? prevState.items
        : this.state.items;
      const archivedItemsUndo = prevState.archivedItems.length
        ? prevState.archivedItems
        : this.state.archivedItems;

      this.setState({ itemsUndo, archivedItemsUndo });
      this.updateArchivedFilesVal();
      instantSave();
    }
  }

  componentDidMount() {
    this._dz = new Dropzone(this._el, {
      url: "#",
      method: "PUT",
      paramName: "file",
      maxFiles: 800, // doesnt seem to work
      maxFilesize: 1000,
      timeout: 0,
      acceptedFiles: null,
      autoProcessQueue: true,
      autoQueue: false,
      createImageThumbnails: false,
      parallelUploads: 2,
      previewTemplate: "<div></div>", // handle all rendering in React
      clickable: "#doc-dropzone-upload-button",
    });

    this._dz.on("addedfile", this.handleAddedFile);
    this._dz.on("sending", this.handleSending);
    this._dz.on("success", this.handleSuccess);
    this._dz.on("uploadprogress", this.handleUploadprogress);
    this._dz.on("error", this.handleError);

    const bodyEl = document.querySelector("body");
    bodyEl.addEventListener("globalDrop", (e) => {
      const allFiles = e.detail;
      const imageFiles = "image/jpeg, image/png, image/tiff, image/gif";
      const files = allFiles.filter(
        (file) => file.type && !imageFiles.includes(file.type)
      );

      this._dz.drop({ dataTransfer: { files } });
    });

    // load pre-existing docs into the component
    if (this.props.itemData) {
      this.setState({
        items: this.props.itemData,
        itemsUndo: this.props.itemData,
      });
    }

    if (this.props.archivedItemData) {
      this.setState({ archivedItems: this.props.archivedItemData });
    }
  }

  render() {
    const { recordType, recordId } = this.props;
    const { items, archivedItems } = this.state;
    const item_list = items
      .map((item) => item.id)
      .filter((i) => !!i)
      .join(",");

    return (
      <>
        <div
          ref={(c) => {
            this._uploader = c;
          }}
          className={Cx({ [styles.dragging]: this.state.isDraggingOver })}
        >
          <input
            className="doc_list"
            name={`${recordType}[doc_list]`}
            id={`${recordType}_doc_list`}
            type="hidden"
            value={item_list}
          />

          <div
            id="docDrop"
            className={styles.items}
            ref={(c) => {
              this._items = c;
            }}
          >
            {!!items.length && (
              <>
                {items.map((item) => (
                  <div
                    className={Cx(styles.item, styles[item.status], {
                      [styles.archivedItemSelected]: item.selected,
                    })}
                    key={item.uuid || item.id}
                  >
                    <div
                      className={styles.details}
                      onClick={(e) => this.handleClickItem(e, item.id)}
                    >
                      <div className={styles.filename}>
                        <span className={styles.filenameArea}>
                          <a
                            href={item.original}
                            target={item.original ? "_blank" : ""}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <span>{item.filename}</span> (
                            <span>{humanFileSize(item.size)}</span>)
                          </a>
                        </span>
                      </div>
                    </div>

                    {(!item.status || item.status === "processed") && (
                      <FileLabelEditor
                        id={item.id}
                        label={item.label || ""}
                        filetype="doc"
                      />
                    )}

                    {!!item.progress && (
                      <div
                        className={styles.progress}
                        style={{ width: `${item.progress}%` }}
                      />
                    )}
                  </div>
                ))}
              </>
            )}
          </div>

          <div
            className={styles.dropzoneObject}
            ref={(c) => {
              this._el = c;
            }}
          />

          <div
            className={styles.dropzoneClickable}
            id="doc-dropzone-upload-button"
          >
            <PlusIcon />
          </div>

          <DocActions
            items={items}
            archivedItems={archivedItems}
            onDocAction={this.handleDocAction}
            onUndo={this.undo}
            uploaderRef={this._uploader}
            recordType={recordType}
            recordId={recordId}
          />
        </div>

        <div
          className="panel file doc-panel closed"
          style={{ display: archivedItems.length ? "block" : "none" }}
          ref={(c) => {
            this._archivedItems = c;
          }}
        >
          <div className="panel-title">Archived Documents</div>
          <div className={styles.archivedItems}>
            <div>
              {archivedItems.map((item, index) => (
                <div
                  className={Cx(styles.item, {
                    [styles.archivedItemSelected]: item.selected,
                  })}
                  key={item.id}
                  onClick={(e) => this.handleClickArchivedItem(e, item.id)}
                >
                  <div className={styles.details}>
                    <div className={styles.filename}>
                      <span className={styles.filenameArea}>
                        <span>{item.filename}</span> (
                        <span>{humanFileSize(item.size)}</span>)
                      </span>
                    </div>
                  </div>

                  <FileLabelEditor
                    id={item.id}
                    label={item.label || ""}
                    filetype="doc"
                    requireLabel={false}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <ArchivedDocActions
          items={items}
          archivedItems={archivedItems}
          onDocAction={this.handleDocAction}
          archivedItemsRef={this._archivedItems}
        />
      </>
    );
  }
}
